<template>
  <div class="area-manage">
    <!-- 条件搜索部分 -->
    <el-form class="zwx-form" key="mainForm" ref="mainForm" :model="mainForm" label-position="right"
             @submit.native.prevent>
      <div class="self-adapting-condition">
        <el-form-item  label="地区编码：">
          <el-input class="zwx-input" v-model="mainForm.zoneCode12Like" placeholder="请输入"
                    @keyup.enter.native="search(1)" clearable/>
        </el-form-item>
        <el-form-item  label="地区名称：">
          <el-input class="zwx-input" v-model="mainForm.zoneNameLike" placeholder="请输入" @keyup.enter.native="search(1)"
                    clearable/>
        </el-form-item>
        <el-form-item label="状态：">
          <el-checkbox-group class="zwx-checkbox-group" v-model="mainForm.ifEnables">
            <el-checkbox class="zwx-checkbox" :label="true">启用</el-checkbox>
            <el-checkbox class="zwx-checkbox" :label="false">停用</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <div class="condition-button-row">
          <el-button class="zwx-button zwx-button-icontext-28" type="primary" icon="el-icon-search" @click="search(1)">查询
          </el-button>
        </div>
      </div>
    </el-form>
    <!-- 列表展示部分 -->
    <el-table class="zwx-table" height=" calc(100vh - 152px)" row-key="rid" :data="dataList" border stripe>
      <el-table-column prop="zoneCode12" label="地区编码" :width="$system.calWidth(dataList, 'zoneCode12', '地区编码')"
                       header-align="center" align="center"/>
      <el-table-column prop="zoneName" label="地区名称" :width="$system.calWidth(dataList, 'zoneName', '地区名称')"
                       header-align="left" align="left"/>
      <el-table-column prop="fullName" label="地区全称" :width="$system.calWidth(dataList, 'fullName', '地区全称')"
                       header-align="left" align="left"/>
      <el-table-column label="地区级别" width="86" header-align="center" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.zoneType === 0">国级</template>
          <template v-if="scope.row.zoneType === 1">省级</template>
          <template v-else-if="scope.row.zoneType === 2">市级</template>
          <template v-else-if="scope.row.zoneType === 3">区县级</template>
          <template v-else-if="scope.row.zoneType === 4">乡镇级</template>
          <template v-else-if="scope.row.zoneType === 5">村级</template>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" :min-width="$system.calMinWidth({ wordNum: 4, arrowNum: 0, btnNum: 3 })"
                       header-align="left" align="left">
        <template slot-scope="scope">
          <el-button class="zwx-button zwx-button-text-26"
                     :style="scope.row.ifEnable ? 'color: #e72b00 !important;' : ''" type="text"
                     @click="$system.msgbox(scope.row, '提示', scope.row.ifEnable ? '确定要停用吗？' : '确定要启用吗？', '确定', '取消', enable)"
                     >{{ scope.row.ifEnable ? '停用' : '启用' }}
          </el-button>
          <el-button class="zwx-button zwx-button-text-26" type="danger"
                     @click="$system.msgbox(scope.row, '提示', '确定要删除吗？', '确定', '取消', deletion)"
                     v-if="!scope.row.ifEnable">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器部分 -->
    <base-pagination :parentPage="currentPage" :pageSize="pageSize" :total="total" @currentChange="currentChange"/>
  </div>
</template>

<script>
export default {
  name: 'AreaManage',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      mainForm: {
        zoneCode12Like: '',
        zoneNameLike: '',
        ifEnables: [true],
      },
      dataList: [],
      currentPage: 1,
      pageSize: 18,
      total: 0,
    }
  },
  created() {
  },
  mounted() {
    this.search(this.currentPage)
  },
  activated() {
    if (this.$route.params.fresh) this.search(this.currentPage)
  },
  computed: {},
  methods: {
    currentChange(currentPage) {
      this.search(currentPage)
    },
    search(currentPage) {
      this.$emit('loading', true)
      this.currentPage = currentPage
      let data = {
        currentPage: this.currentPage,
        zoneCode12Like: this.mainForm.zoneCode12Like,
        zoneNameLike: this.mainForm.zoneNameLike,
        ifEnable: this.mainForm.ifEnables.length === 1 ? this.mainForm.ifEnables[0] : null,
      }
      this.$system.get(this.api + '/systematic/getAreaList-1', data, true, true, this.searchSuccess, this.error)
    },
    searchSuccess(data) {
      if (data.type === '00') {
        this.dataList = data.areaList
        this.total = data.areaCount
        this.pageSize = data.pageSize
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
      }
      this.$emit('loading', false)
    },
    enable(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid, ifEnable: !row.ifEnable}
      this.$system.post(this.api + '/systematic/modifyAreaState-1', data, true, true, this.enableSuccess, this.error)
    },
    enableSuccess(data) {
      if (data.type === '00') {
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    deletion(row) {
      this.$emit('loading', true)
      let data = {rid: row.rid}
      this.$system.post(this.api + '/systematic/deleteArea-1', data, true, true, this.deletionSuccess, this.error)
    },
    deletionSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.search(this.currentPage)
      } else if (data.type === '99') {
        this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    error() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
